module.exports = __webpack_public_path__ + "img/2.b16ca087.jpg";